export const passwordRequirementRegExp = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-*.!@$%^&(){}[\]:;<>,.?/~_+=|])/

export const recoveryCodeRegExp = /^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/
